import React from 'react';
import { Track } from 'angieslist-app-platform';
import isTouchDevice from 'is-touch-device';
import {
  Row,
  Col,
  RatingDisplaySingleStar,
  Button,
} from 'angieslist-react-components';
import classNames from 'classnames';
import './BusinessCard.scss';
import type { Address } from '../../../../../../../app/types';

type ServiceProviderTypes = {
  proType: String,
  starRating: Number,
  displayReviewCount: Number,
  primaryAddress?: Address,
  name: String,
  id: Number,
  activityCount: Number,
  accessEndsAt: String,
};

type BusinessCardProps = {
  sp: ServiceProviderTypes,
  onCardClicked: (id: number, proType: string) => void,
};

const usingTouchDevice = isTouchDevice();

const BusinessCard = (props: BusinessCardProps) => {
  const {
    sp: {
      proType,
      starRating = 0,
      displayReviewCount,
      primaryAddress,
      name,
      id,
      activityCount,
      accessEndsAt,
    },
    onCardClicked,
  } = props;

  const onBusinessCardClicked = (e) => {
    e.stopPropagation();
    onCardClicked(id, proType);
  };

  const formatToLocalTime = (utcDateTimeString) => {
    const date = new Date(utcDateTimeString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <Track>
      <Col className="business-card" id="sp-business-card" onClick={onBusinessCardClicked} spid={id}>
        <Row>
          <Col lg={7} md={11} sm={11} xs={10}>
            <div className="business-details">
              <div className="business-pills">
                <div className="business-source">{`Angi ${proType}`}</div>
                {proType === 'Leads' && accessEndsAt && (
                  <div className="business-delegation-expiration">
                    {`Delegation expires at ${formatToLocalTime(accessEndsAt)}`}
                  </div>
                )}
              </div>
              <div className="h4 business-name" title={name}>
                {name}
              </div>
              <If condition={primaryAddress}>
                <h4
                  className="h4 business-region"
                  title={primaryAddress.city !== undefined ? primaryAddress.city.name : ''}
                >
                  <div className="business-city">{primaryAddress.city !== undefined ? primaryAddress.city.name : ''}</div>
                  <div>{primaryAddress.region !== undefined ? `, ${primaryAddress.region.name}` : ''}</div>
                </h4>
              </If>
            </div>
          </Col>
          <Col lg={2} mdHidden smHidden xsHidden>
            <div
              className={classNames('business-info', {
                gray: starRating === 0,
              })}
            >
              <RatingDisplaySingleStar
                rating={starRating}
                starSize="1.2em"
                ratingFontSize="14px"
              />
              <div className="rating-value">
                <span>({displayReviewCount})</span>
              </div>
            </div>
          </Col>
          <Col
            lg={2}
            mdHidden
            smHidden
            xsHidden
            className={classNames({
              'hide-on-hover': !usingTouchDevice,
            })}
          >
            <div className="business-info spid">ID: {id}</div>
          </Col>
          { activityCount > 0 && (
            <Col
              lg={1}
              mdHidden
              smHidden
              xsHidden
              className={classNames({
                'hide-on-hover': !usingTouchDevice,
              })}
            >
              <div className="business-info status">
                <i className="icon icon-circle" />
              </div>
            </Col>
          )}
          { activityCount > 0 && (
            <Col lgHidden md={1} sm={1} xs={2}>
              <div className="business-info status">
                <i className="icon icon-circle" />
              </div>
            </Col>
          )}
          {!usingTouchDevice && (
            <Col lg={3} mdHidden smHidden xsHidden className="show-on-hover">
              <div className="business-info">
                <Button id="card-select-btn" className="choose-btn" onClick={onBusinessCardClicked}>
                  Choose
                </Button>
              </div>
            </Col>
          )}
        </Row>
        <Row>
          <Col md={3} lgHidden sm={4} xs={6}>
            <div
              className={classNames('business-info sm-view', {
                gray: starRating === 0,
              })}
            >
              <RatingDisplaySingleStar
                rating={starRating}
                starSize="1.2em"
                ratingFontSize="14px"
              />
              <div className="rating-value">
                <span>({displayReviewCount})</span>
              </div>
            </div>
          </Col>
          <Col md={3} lgHidden sm={4} xs={6} smOffset={4}>
            <div className="business-info spid sm-view">ID: {id}</div>
          </Col>
        </Row>
      </Col>
    </Track>
  );
};

export default BusinessCard;



// WEBPACK FOOTER //
// ./src/modules/home/modules/browser/home/BusinessList/components/BusinessCard.js